<template>
  <div class="md:mt-0 lg:mt-0 mt-6 rounded-b-lg shadow-xl bg-white">
    <a class="cursort-pointer" target="_blank" :href="url">
      <img
        :src="hasError ? defaultImage : image"
        alt="News image"
        class="rounded-t-lg h-52 w-full object-contain cursor-pointer"
        @error="hasError = true"
      />
      <div class="p-4">
        <p
          class="text-black footertitle font-bold cursor-pointer fsize20-14px ellipsis-2"
        >
          {{ item.title }}
        </p>
      </div>
      <!-- <div class="md:mt-5 lg:mt-5 mt-2 flex">
        <p class="text-xs clr777 font-normal">1 Hour ago</p>
                <p class="text-xs clr777 font-normal ml-6">200 views</p>
      </div> -->
    </a>
  </div>
</template>

<script>
// import blogMixin from "../mixins/blogMixin";

export default {
  // mixins: [blogMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
  },
  data() {
    return {
      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.defaultImage;
    },
    url() {
      if (this.item.link.includes("http")) {
        return this.item.link;
      } else {
        return "https://" + this.item.link;
      }
    },
  },
};
</script>
